import { useTranslation } from 'react-i18next';
import { useActiveOrganization } from '@/graphql/queries/organizations';
import { useCurrentOrgId } from '@/store/use-my-oganization-store';
import { LetterheadSection } from '../components/letterhead-section';
import { Skeleton } from '@/components/ui-kit/skeleton';

const OrgLetterheadsPage = () => {
  const { t } = useTranslation();
  const orgId = useCurrentOrgId();
  const { data: org, isLoading } = useActiveOrganization();

  if (isLoading) {
    return <Skeleton className="h-64 w-full" />;
  }

  if (!org || !orgId) return null;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-[hsl(var(--fg))] font-heading">
          {t('ORGSETTINGS_LETTERHEADS_LABEL')}
        </h2>
        <p className="text-sm text-globe-grey mt-1">{t('ORGSETTINGS_LETTERHEADS_DESCRIPTION')}</p>
      </div>

      <LetterheadSection orgId={orgId} />
    </div>
  );
};

export default OrgLetterheadsPage;
